import { ComponentProps } from "react";
import { css } from "@emotion/react";
import { ContentCardScaffold } from "../contents/cards/scaffolds/ContentCardScaffold";
import { ArchiveVerticalCard } from "./ArchiveVerticalCard";
import { ArchiveHorizontalCard } from "./ArchiveHorizontalCard";

export type ArchiveItem = {
  id: string;
  title: string;
  source: string;
  sourcename: string;
  mix_archive_sourcename?: {
    imgurl?: string | null;
    source: string;
    sourcename: string;
  } | null;
  view_url: string;
  download_url: string;
  thumbnail_url?: string | null;
  tags?: Array<string> | null;
  created_at?: any | null;
  updated_at?: any | null;
  bookmarked?: boolean;
};

const desktopStyle = css`
  display: flex;

  @media (max-width: 768px) {
    display: none;
  }
`;

const mobileStyle = css`
  display: none;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const ArchiveCard = ({
  device,
  onDownload,
  isGuest = false,
  ...props
}: Omit<ComponentProps<typeof ContentCardScaffold>, "children"> & {
  archive: ArchiveItem;
  tagEnums: Array<{ value: string; comment?: string | null }>;
  onClick?: () => void;
  onDownload?: (e: React.MouseEvent) => void;
  device?: "web+tablet" | "app";
  isGuest?: boolean;
}) => {
  const map = {
    "web+tablet": <ArchiveVerticalCard {...props} onDownload={onDownload} isGuest={isGuest} />,
    app: <ArchiveHorizontalCard {...props} onDownload={onDownload} isGuest={isGuest} />,
  };

  return device ? (
    map[device]
  ) : (
    <>
      <ArchiveVerticalCard css={desktopStyle} {...props} onDownload={onDownload} isGuest={isGuest} />
      <ArchiveHorizontalCard css={mobileStyle} {...props} onDownload={onDownload} isGuest={isGuest} />
    </>
  );
};
